module.exports = __webpack_public_path__ + "static/media/arabic01.f64a9af2.svg";